import React, { useState, useRef, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";

const API_URL = process.env.REACT_APP_API_URL; // precisa estar definido no .env

export default function CampoEmpresa({ filtroCliente, setFiltroCliente }) {
  const [openEmpresa, setOpenEmpresa] = useState(false);
  const [clientes, setClientes] = useState([]);
  const refEmpresa = useRef(null);

  // 🔹 Carregar lista de clientes (listar.php)
  useEffect(() => {
    const carregarClientes = async () => {
      try {
        const resp = await fetch(`${API_URL}/cliente/listar.php`);
        const contentType = resp.headers.get("content-type");

        if (contentType && contentType.includes("application/json")) {
          const json = await resp.json();
          console.log("🔎 Retorno da API:", json);

          if (
            json &&
            (json.status === "success" || json.status === "sucesso") &&
            Array.isArray(json.dados)
          ) {
            setClientes(json.dados);
          } else {
            setClientes([]);
          }
        } else {
          console.error("Resposta não é JSON:", await resp.text());
          setClientes([]);
        }
      } catch (error) {
        console.error("Erro ao buscar clientes:", error);
        setClientes([]);
      }
    };
    carregarClientes();
  }, []);

  // 🔹 Fecha dropdown ao clicar fora
  useEffect(() => {
    const handler = (e) => {
      if (refEmpresa.current && !refEmpresa.current.contains(e.target)) {
        setOpenEmpresa(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const inputBaseClasses = `
    peer w-full h-10 px-2 border-b-[1px] border-gray-300
    focus:border-blue-600 focus:ring-0 focus:outline-none
    text-base text-gray-900 bg-transparent placeholder-transparent
  `;

  const labelBaseClasses = (value) => `
    absolute left-2 transition-all duration-200 pointer-events-none
    ${value ? "-top-4 text-sm font-bold text-gray-900" : "top-2 text-base text-gray-400"}
    peer-focus:-top-4 peer-focus:text-sm peer-focus:font-bold peer-focus:text-gray-900
  `;

  const clientesFiltrados = clientes.filter((c) =>
    (c.nome_fantasia || c.razao_social || "")
      .toLowerCase()
      .includes(filtroCliente.toLowerCase()) ||
    (c.razao_social || "").toLowerCase().includes(filtroCliente.toLowerCase())
  );

  return (
    <div className="relative flex-[2] min-w-[250px]" ref={refEmpresa}>
      <input
        type="text"
        value={filtroCliente}
        onChange={(e) => {
          setFiltroCliente(e.target.value);
          setOpenEmpresa(true);
        }}
        placeholder=" "
        className={inputBaseClasses}
      />
      <label className={labelBaseClasses(filtroCliente)}>Nome da Empresa</label>

      <ChevronDown
        size={16}
        className={`absolute right-1 top-3 transition-transform ${
          openEmpresa ? "rotate-180" : "rotate-0"
        }`}
        onClick={() => setOpenEmpresa((prev) => !prev)}
      />

      <AnimatePresence>
        {openEmpresa && (
          <motion.ul
            initial={{ opacity: 0, y: -5 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -5 }}
            transition={{ duration: 0.2 }}
            className="absolute left-0 right-0 mt-1 bg-white border border-gray-300 
                       rounded-md shadow-md z-10 max-h-52 overflow-y-auto"
          >
            {clientesFiltrados.length > 0 ? (
              clientesFiltrados.map((c) => (
                <li
                  key={c.codigo}
                  className="px-3 py-2 text-sm text-gray-700 border-b last:border-0"
                >
                  {/* Razão Social */}
                  {c.razao_social && (
                    <div
                      onMouseDown={() => {
                        setFiltroCliente(c.razao_social);
                        setOpenEmpresa(false);
                      }}
                      className="cursor-pointer hover:bg-blue-100 px-2 py-1 rounded font-semibold text-gray-900"
                    >
                      {c.razao_social}
                    </div>
                  )}

                  {/* Nome Fantasia */}
                  {c.nome_fantasia && (
                    <div
                      onMouseDown={() => {
                        setFiltroCliente(c.nome_fantasia);
                        setOpenEmpresa(false);
                      }}
                      className="cursor-pointer hover:bg-blue-100 px-2 py-1 rounded text-gray-700"
                    >
                      {c.nome_fantasia}
                    </div>
                  )}
                </li>
              ))
            ) : (
              <li className="px-3 py-2 text-sm text-gray-500">
                Nenhum cliente encontrado
              </li>
            )}
          </motion.ul>
        )}
      </AnimatePresence>
    </div>
  );
}
